import { render, staticRenderFns } from "./cardWorker.vue?vue&type=template&id=2d47ed98&scoped=true&"
import script from "./cardWorker.vue?vue&type=script&lang=js&"
export * from "./cardWorker.vue?vue&type=script&lang=js&"
import style0 from "./cardWorker.vue?vue&type=style&index=0&id=2d47ed98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d47ed98",
  null
  
)

export default component.exports